import React from 'react';
import styled from "styled-components";


export const CarouselFlex = (props) => {
  return (
      <Section bgImage={props.bgImage}>
          <Wrapper className={props.classId}>
              <ContentList
                  className={`${props.classId}-carousel`}
                  id={props.divId}
                  role="region" 
                  aria-label={props.divId}
                  tabindex="0">
                  {
                    props.children.map((item, key) => (
                        <ListItem key={key}> {item} </ListItem>
                    ))
                  }                    
              </ContentList>
          </Wrapper>
      </Section>
  )
};


const Section = styled.div`
    position: relative;
    width: 100%;
`;

const Wrapper = styled.div`
    margin: 0 auto;

    &.recomendations{
        width: 100%;
    }
`;

const ContentList = styled.div`
    width: 100%;    
    padding: 10px 0px;
    display: flex;
    flex-wrap: wrap;

    &.recomendations-carousel{
        justify-content: flex-start;
        padding: 0px;
    }
    
    &::-webkit-scrollbar {
        display: none;
    }
    
    @media (max-width: 640px) {
        /* flex-wrap: nowrap;
        overflow-x: scroll;
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch; */
    }

    @media (max-width: 481px) {
        padding: 0;
    }
`;

const ListItem = styled.div` 
    position: relative;
    margin: 10px;
    background-color: #fff;
    border-radius: 14px;
    cursor: pointer;
    overflow: hidden;

    min-height: 300px;

    @media (max-width: 640px) {
        width: calc(100% - 20px);
    }

    /* Small devices such as large phones (640px and up) */
    @media only screen and (min-width: 40em) {
        width: calc(100% / 2 - 20px);
    }

    /* Large devices such as laptops (1024px and up) */
    @media only screen and (min-width: 64em) {
        width: calc(100% / 4 - 20px);
    }

    /* Largest devices such as desktops (1280px and up) */
    @media only screen and (min-width: 80em) {
        width: calc(100% / 4 - 20px);
    }
`;


export default CarouselFlex;